import { AuthShell, SignUpForm, useAuth } from "@nexys/user-management-web";
import { Link, useNavigate } from "react-router-dom";

export const SignUpPage = () => {
  const { refresh } = useAuth();
  const navigate = useNavigate();

  return (
    <AuthShell brand="UM-RS Console">
      <SignUpForm
        onSuccess={async () => {
          // Sign-up auto-signs-in; refresh the snapshot then go home.
          await refresh();
          navigate("/", { replace: true });
        }}
        signInSlot={
          <>
            Already have an account?{" "}
            <Link to="/sign-in" className="font-medium text-primary hover:underline">
              Sign in
            </Link>
          </>
        }
      />
    </AuthShell>
  );
};
